import environmentConfig from './enviromentConfig';
import { storageKey } from './storageKey';

const isDevEnv = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';
const envConfig = isDevEnv ? environmentConfig.development : environmentConfig.production;
const domain = 'https://api-samngoclinh.meu-solutions.com/';
const endPointAdmin = 'https://apiadmin-samngoclinh.meu-solutions.com/api/v1.0/';

const SUCCESS = 'success';
const FAIL = 'fail';
const INVALIDPW = 902;
const INVALIDEMAIL = 901;
const Duplicate = 'trùng mã sản phẩm';
const Config = {
    isDevEnv,
    storageKey,
    apiConfig: {
        ...envConfig,
    },
    domain,
    SUCCESS,
    FAIL,
    endPointAdmin,
    INVALIDPW,
    INVALIDEMAIL,
    Duplicate,
};

export default Config;
